import { environment } from "../../../environments/environment";
import { AnaColumn } from "../forms-template.service";

export const crmAgentiGrid: AnaColumn[] = [


  {
    configuration:
    {
      service: 'crmAgentiForm', 

      api: 'agenti',
      api_rest: true,
      filterList: '',
      filterEditor: '/$',
      // helpDoc: 'Movimentidicaricoescaricorifiuti.html',
      formType: 'simple',
      queryFilter: [],
      idTabRif: [],
      masterKey: 'Cod',
      nCol: 2,
      //ListaHP=H12&ListaHP=H2&ListaHP=H4&
    },

    itemType: "group", colCount: "1", class: "", caption: "Agenti",
    data: [

      // {
      //   type: 'campo',
      //   dataField: 'Cod',
      //   colVisible: false,
      //   visible: false,

      //   dataType: 'string',
      //   caption: 'Cod',
      //   colAlignment: 'center',
      //   colWidth: 50,

      // },

      {
        type: 'campo',
        dataField: 'RagSoc1',
        colVisible: true,
        dataType: 'string',
        caption: 'Ragione Sociale',
        colAlignment: 'left',
        colWidth: 300
      },
      // {
      //   type: 'campo',
      //   dataField: 'RagSoc2',
      //   colVisible: true,
      //   dataType: 'string',
      //   caption: 'Ragione Sociale 2',
      //   colAlignment: 'left',
      //   colWidth: 260
      // },

      {
        type: 'campo',
        dataField: 'Resp',
        colVisible: true,
        dataType: 'string',
        caption: 'Responsabile',
        colAlignment: 'left',
        colWidth: 200
      },

      // {
      //   type: 'campo',
      //   dataField: 'id_regione',
      //   colVisible: true,
      //   dataType: 'string',
      //   caption: 'Regione',
      //   colWidth: 300,
      //   allowFiltering: false,
      //   colAlignment: 'left',
      //   editorType: 'dxSelectBox',
      //   lista: {
      //     dataSource: 'regioni',
      //     displayExpr: 'nome',
      //     valueExpr: 'id',
      //     static: false
      //   }
      // },
      {
        type: 'campo',
        dataField: 'Ind',
        colVisible: false,
        dataType: 'string',
        caption: 'Indirizzo',
        colAlignment: 'left',
        colWidth: 300
      },
      {
        type: 'campo',
        dataField: 'Cap',
        colVisible: false,
        dataType: 'string',
        caption: 'Cap',
        colAlignment: 'center',
        colWidth: 80
      },
      {
        type: 'campo',
        dataField: 'id_localita',
        colVisible: false,
        dataType: 'string',
        caption: 'Comune',
        colAlignment: 'left',
        width: 180,
        lista: {
          dataSource: 'comuni',
          valueExpr: 'id',
          displayExpr: 'nome',
          wingap: false,
        }
      },
      {
        type: 'campo',
        dataField: 'id_provincia',
        colVisible: false,
        dataType: 'string',
        caption: 'Provincia',
        colAlignment: 'left',
        width: 80,
        lista: {
          dataSource: 'province',
          valueExpr: 'id',
          displayExpr: 'sigla_automobilistica',
          wingap: false,
        }
      },



      {
        type: 'campo',
        dataField: 'Zona',
        colVisible: true,
        dataType: 'string',
        caption: 'Zona',
        colAlignment: 'left',
        colWidth: 260
      },
      {
        type: 'campo',
        dataField: 'Tel',
        colVisible: true,
        dataType: 'string',
        caption: 'Telefono',
        colAlignment: 'center',
      },
      {
        type: 'campo',
        dataField: 'Cell',
        colVisible: true,
        dataType: 'string',
        caption: 'Cellulare',
        colAlignment: 'center',
      },
      // {
      //   type: 'campo',
      //   dataField: 'Fax',
      //   colVisible: true,
      //   dataType: 'string',
      //   caption: 'Fax',
      //   colAlignment: 'center',
      //   colWidth: 120
      // },

      {
        type: 'campo',
        dataField: 'Mail',
        colVisible: true,
        dataType: 'string',
        caption: 'E-mail',
        colAlignment: 'left',
      },
      {
        type: 'campo',
        dataField: 'MailAzienda',
        colVisible: false,
        dataType: 'string',
        caption: 'E-mail Aziendale',
        colAlignment: 'left',
        colWidth: 480
      },
      {
        type: 'campo',
        dataField: 'Fax',
        colVisible: true,
        dataType: 'string',
        caption: 'Pec-Email',
        colAlignment: 'left',
        colWidth: 210
      },
      {
        type: 'campo',
        dataField: 'Annot1',
        colVisible: false,
        dataType: 'string',
        caption: 'Annotazioni',
        colAlignment: 'left',
        colWidth: 350
      },
      {
        type: 'campo',
        dataField: 'Annot2',
        colVisible: false,
        dataType: 'string',
        caption: 'Annotazioni',
        colAlignment: 'left',
        colWidth: 300
      },
      {
        type: 'campo',
        dataField: 'stato',
        colVisible: true,
        dataType: 'string',
        caption: 'Stato',
        colAlignment: 'center',
        width: 40,
        lista: {
          dataSource: 'Stato',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          static: true,

        }
      },

    ]
  },
];

export const crmAgentiForm: AnaColumn[] = [


  {
    itemType: 'group',
    caption: 'Informazioni Generali',
    class: '',
    colCount: '4',
    data: [

      {
        type: 'campo',
        dataType: 'string',
        dataField: 'Cod',
        caption: 'Codice Id',
        visible: false,
        // validation: [{ type: "required", message: "Campo Obbligatorio" }],
        class: 'crm_agent_editor',
        nCol: 3,
      },

      {
        type: 'campo',
        dataType: 'string',
        dataField: 'RagSoc1',
        caption: 'Ragione Sociale',
        class: 'crm_agent_editor',
        nCol: 5,
        maxLength: 45,
        validation: [
          { type: "required", message: "Campo Ragione Sociale obbligatorio" },
        ],
      },
      {
        type: 'campo',
        dataType: 'string',
        dataField: 'RagSoc2',
        caption: 'Ragione Sociale Extra',
        class: 'crm_agent_editor',
        nCol: 5,
        maxLength: 45,
      },
      { type: 'empty', colSpan: '4', },
      //-------------------------------------------------------------------------
      {
        type: 'campo',
        dataType: 'string',
        dataField: 'Resp',
        caption: 'Responsabile',
        class: 'crm_agent_editor',
        nCol: 7,
        maxLength: 45,
        validation: [
          { type: "required", message: "Campo Responsabile obbligatorio" },
        ],
      },
      {
        type: 'campo',
        dataType: 'string',
        dataField: 'stato',
        caption: 'Stato',
        nCol: 3,
        class: 'crm_agent_editor',
        editorType: 'dxSelectBox',
        lista: {
          selectFirstElement: true,
          isDefaultOption: false,
          valueExpr: 'id',
          displayExpr: 'value',
          dataSource: '',
          static: true,
          items: [
            { id: 1, value: 'Attivo' },
            { id: 0, value: 'Disattivo' },
          ]
        }
      },
      { type: 'empty', colSpan: '4', },
      //----------------------------------------------------------------
      {
        type: 'campo',
        class: 'crm_agent_editor',
        dataField: 'Ind',
        colVisible: true,
        dataType: 'string',
        caption: 'Indirizzo',
        nCol: 8,
        maxLength: 45,
        validation: [
          { type: "required", message: "Campo Indirizzo obbligatorio" },
        ],
      },
      {
        type: 'campo',
        class: 'crm_agent_editor',
        dataField: 'Civico',
        colVisible: true,
        dataType: 'string',
        caption: 'Civico',
        nCol: 2,
        maxLength: 15,
        validation: [
          { type: "required", message: "Campo Civico obbligatorio" },
        ],
      },
      { type: 'empty', colSpan: '4', },

      //-------------------------------------------------------------------------
      /* {
         type: 'campo',
         dataType: 'string',
         dataField: 'id_regione', 
         caption: 'Regione',
         class: 'crm_agent_editor',
         nCol:5,
       },*/

      {
        type: 'campoSpecial',
        dataField: 'id_regione',
        colVisible: true,
        dataType: 'grid',
        nCol: 5,
        visible: false,
        showClearButton: false,
        showInColumnChooser: true, allowHiding: false,
        disableOnUpdate: true,
        caption: 'Regione',
        class: 'crm_agent_editor ',
        colAlignment: 'left',
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: 'nome',
          campoTabRif: 'id',
          dataSource: 'regioni',
          service: '',
          autocomplete: true,
          caption: 'Lista Località',
          filterStatic: "",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Località',
            name: 'Loc',
            location: 'after',
          },
          settingGrid: {
            masterKey: 'id',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 630,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: true, //Cerca Valore e seleziona
            searchType: 'contains',
            width: 600,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: true,
            overrideDataSource: null,
            concatDataField: null,
            colonne: [
              {
                dataField: 'id',
                dataType: '',
                caption: 'Codice',
                allowEditing: true,
                colVisible: false
              },
              {
                dataField: 'nome',
                dataType: '',
                caption: 'Nome',
                allowEditing: true,
              },
            ],
          },
        },
      },
      {
        type: 'campo',
        dataField: 'Cap',
        class: 'crm_agent_editor',
        dataType: 'string',
        caption: 'CAP',
        nCol: 2,
        maxLength: 5,
        acceptOnlyCharacters: environment.ONLY_NUMBER_CHARACTERS,
        validation: [
          { type: "required", message: "Campo CAP obbligatorio" },
        ],
      },
      {
        type: 'campoSpecial',
        dataType: 'string',
        dataField: 'id_localita',
        caption: 'Comuni',
        class: 'crm_agent_editor',
        nCol: 6,
        showClearButton: false,
        showInColumnChooser: true, allowHiding: false,
        disableOnUpdate: true,
        editorType: '',
        validation: [
          { type: "required", message: "Campo Comuni obbligatorio" },
        ],
        dynamic:
        {
          valueExpr: 'id',
          queryString: '',
          displayExpr: 'nome',
          campoTabRif: 'id',
          related:
            [
              'id_regione|id_regione',
              'id_provincia|id_provincia'
            ],
          dataSource: 'comuni',
          service: '',
          autocomplete: false,
          caption: 'Lista Comuni',
          filterStatic: "",
          componentType: 'dynamicGrid',
          buttonOption:
          {
            text: 'Lista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Comuni',
            name: 'Loc',
            location: 'after',
          },
          settingGrid:
          {
            masterKey: 'id',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 630,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: true, //Cerca Valore e seleziona
            searchType: 'contains',
            width: 600,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: true,
            overrideDataSource: null,
            concatDataField: null,
            colonne:
              [
                {
                  dataField: 'id',
                  dataType: '',
                  caption: 'Codice',
                  allowEditing: true,
                  colVisible: false
                },
                {
                  dataField: 'id_regione',
                  dataType: '',
                  caption: 'Codice Regione',
                  allowEditing: true,
                  colVisible: false,
                },
                {
                  dataField: 'id_provincia',
                  dataType: '',
                  caption: 'Codice Provincia',
                  allowEditing: true,
                  colVisible: false
                },
                {
                  dataField: 'nome',
                  dataType: '',
                  caption: 'Nome',
                  allowEditing: true,
                },
                {
                  dataField: 'codice_catastale',
                  dataType: '',
                  caption: 'Codice Catastale',
                  allowEditing: true,
                  colVisible: false
                },
              ],
          },
        },
      },

      {
        type: 'campoSpecial',
        dataType: '',
        dataField: 'id_provincia',
        class: 'crm_agent_editor',
        nCol: 2,
        showClearButton: false,
        showInColumnChooser: true, allowHiding: false,
        disableOnUpdate: true,
        caption: 'Provincia',
        dynamic: {
          valueExpr: 'id',
          displayExpr: 'sigla_automobilistica',
          dataSource: 'province',
          campoTabRif: 'id',
          service: '',
          autocomplete: true,
          caption: 'Lista Province',
          filterStatic: "",
          componentType: 'dynamicGrid',
          // buttonOption: {
          //   text: 'Lista',
          //   icon: 'glyphicon mdi mdi-playlist-plus',
          //   hint: 'Lista Province',
          //   name: 'Reg',
          //   location: 'after',
          // },
          settingGrid: {
            masterKey: 'id',
            keyUnique: '',
            wingap: false,
            mode: 'cell',
            selectionMode: 'single',
            remoteOperations: true,
            hoverStateEnabled: true,
            rowAlternationEnabled: true,
            repaintChangesOnly: true,
            showFilterSearch: false,
            allowUpdating: false,
            allowDeleting: false,
            allowAdding: false,
            height: 500,
            showColBlank: false,
            campoTabRif: '',
            searchAndSelect: true, //Cerca Valore e seleziona
            searchType: 'contains',
            width: 500,
            toolbarButtonsBottomLeft: null,
            toolbarButtonsBottomRight: [0],
            isOdata: false,//per skip e top in query
            overrideDataSource: null,
            concatDataField: null,
            colonne: [
              {
                dataField: 'id',
                dataType: '',
                caption: 'Codice',
                allowEditing: true,
                colVisible: false,
                colAlignment: 'center'
              },
              {
                dataField: 'id_regione',
                dataType: '',
                caption: 'Codice',
                allowEditing: true,
                colVisible: false,
                colAlignment: 'center'
              },
              {
                dataField: 'nome',
                dataType: '',
                caption: 'Nome',
                allowEditing: true,
              },
              {
                dataField: 'sigla_automobilistica',
                dataType: '',
                caption: 'Sigla',
                allowEditing: true,
              },

            ],
          },
        },

      },


      { type: 'empty', colSpan: '4', },
      //-------------------------------------------------------------------------
      {
        type: 'campo',
        dataField: 'Zona',
        dataType: 'string',
        caption: 'Zona Operativa',
        class: 'crm_agent_editor',
        nCol: 10,
        maxLength: 255,
      },


      { type: 'empty', colSpan: '4', },
      //-------------------------------------------------------------------------
      {
        type: 'campo',
        dataType: 'string',
        dataField: 'Annot2',
        caption: 'Note',
        class: 'crm_agent_editor',
        nCol: 10,
        editorType: "textAreaWithBtn",
        maxLength: 45,
      },
      { type: 'empty', colSpan: '4', },
      //-------------------------------------------------------------------------
    ]
  },
  {
    itemType: 'group',
    caption: 'Informazioni di Contatto',
    class: '',
    colCount: '4',
    data: [

      {
        type: 'campo',
        dataType: 'string',
        dataField: 'Tel',
        caption: 'Telefono',
        class: 'crm_agent_editor ',
        nCol: 5,
        maxLength: 18,
        validation: [
          {type: 'pattern', value: "^\\+?[0-9\\-/]*$", message: 'Numero di telefono non valido.'},
          {type: 'required', message: 'Campo Telefono obbligatorio.'}
        ]
      },
      {
        type: 'campo',
        dataType: 'string',
        dataField: 'Cell',
        caption: 'Cellulare',
        class: 'crm_agent_editor',
        nCol: 5,
        maxLength: 18,
        validation: [
          {type: 'pattern', value: "^\\+?[0-9\\-/]*$", message: 'Numero di telefono non valido.'},
          {type: 'required', message: 'Campo Cellulare obbligatorio.'}
        ]
      },

      { type: 'empty', colSpan: '4', },
      //-------------------------------------------------------------------------

      {
        type: 'campo',
        dataType: 'string',
        dataField: 'Fax',
        caption: 'Pec-Email',
        class: 'crm_agent_editor',
        nCol: 10,
        maxLength: 18,
        validation: [
          { type: "required", message: "Campo Pec-Email obbligatorio" },
        ],
      },
      { type: 'empty', colSpan: '4', },

      //----------------------------------------------------------------

      {
        type: 'campo',
        dataType: 'string',
        dataField: 'Mail',
        caption: 'E-mail',
        class: 'crm_agent_editor',
        nCol: 5,
        maxLength: 45,
        validation: [
          { type: "required", message: "Campo Email obbligatorio" },
        ],
      },

      
      {
        type: 'campo',
        dataType: 'string',
        dataField: 'MailAzienda',
        caption: 'E-mail Aziendale',
        class: 'crm_agent_editor',
        nCol: 5,
        maxLength: 255,
      },

      { type: 'empty', colSpan: '4', },

      //----------------------------------------------------------------

      {
        type: 'campo',
        dataType: 'string',
        dataField: 'Sito',
        caption: 'Sito Web',
        class: 'crm_agent_editor',
        nCol: 10,
        maxLength: 255,
        button: {
          name: 'apriLink',
          hint: 'Apri Link',
          icon: 'bi bi-link-45deg',
          event: 'apriLink',
          disabled: false,
          visible: true,
        }
      },

      { type: 'empty', colSpan: '4', },
      //----------------------------------------------------------------


      {
        type: 'campo',
        dataType: 'string',
        dataField: 'Social1',
        caption: 'Linkedin',
        class: 'crm_agent_editor',
        nCol: 10,
        button: {
          name: 'apriLink',
          hint: 'Apri Link',
          icon: 'bi bi-link-45deg',
          event: 'apriLink',
          disabled: false,
          visible: true,
        }
      },

      { type: 'empty', colSpan: '4', },
      //----------------------------------------------------------------

      {
        type: 'campo',
        dataType: 'string',
        dataField: 'Social2',
        caption: 'Facebook',
        class: 'crm_agent_editor',
        nCol: 10,
        button: {
          name: 'apriLink',
          hint: 'Apri Link',
          icon: 'bi bi-link-45deg',
          event: 'apriLink',
          disabled: false,
          visible: true,
        }
      },

      { type: 'empty', colSpan: '4', },
      //----------------------------------------------------------------

    ]
  },
  /*   {
      itemType: 'group',
      caption: 'Note',
      class: '',
      colCount: 4,
      colSpan: 2,
      data: [
  
        {
          type: 'campo',
          dataType: 'string',
          dataField: 'Annot1',
          caption: 'Annotazioni',
          class: ' ann-height crm_agent_editor ',
          nCol: 5,
        },
        {
          type: 'campo',
          dataType: 'string',
          dataField: 'Annot2',
          caption: 'Annotazioni 2',
          class: ' ann-height crm_agent_editor ms-3',
          nCol: 5,
        },
  
        { type: 'empty', colSpan: '4', },
  
      ]
    }, */
];